import { SVGProps, Ref, forwardRef } from 'react';

export const PauseOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.998 11.997c0 1.75-.25 2-2 2S3 13.747 3 11.997V4c0-1.75.25-2 2-2s2 .25 2 2zm-1.4 0c0 .259-.006.446-.017.583a8 8 0 0 1-.582.017c-.259 0-.446-.007-.583-.017a8 8 0 0 1-.017-.583V4c0-.258.006-.446.017-.582.137-.01.324-.017.583-.017s.445.006.582.017c.01.136.017.324.017.582z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.997 11.997c0 1.75-.25 2-2 2s-2-.25-2-2V4c0-1.75.25-2 2-2s2 .25 2 2zm-1.4 0c0 .259-.007.446-.017.583-.137.01-.324.017-.583.017s-.446-.007-.582-.017a8 8 0 0 1-.017-.583V4c0-.258.006-.446.017-.582.136-.01.324-.017.582-.017.259 0 .446.006.583.017.01.136.017.324.017.582z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PauseOutlinedSize16Glyph.displayName = 'PauseOutlinedSize16Glyph';
